<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KI15W3/media/FC-9781685624002.jpg?1718046561632" alt="This image is the cover for the book The Warriors of Raw: The Battle for Souls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Warriors of Raw: The Battle for Souls
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Aptos",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>In the Kingdom of Old York New, ancient demonic adversaries rise once more, casting shadows of chaos. The new generation of the Warriors of Raw is humanity’s last line of defense. Their mission? Locate the elusive Shaft of Light, reforge the legendary Spear of Destiny, and turn the tide of the impending Demon War.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Aptos",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>But with the very fabric of time hanging in the balance, can they prevent the malevolent forces from rewriting the past, present, and future? Dive into a tale where every battle is a race against time and destiny itself.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynn Mathai
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Lynn Mathai grew up in Queens, New York. He faced many disabilities while growing up and, although he worked through some, he still faces many of them today. Lynn enjoys writing stories for his nephews and niece. He is an avid reader and has always enjoyed fantasy, science fiction, and adventure books.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f728a38